import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack, TextField, Typography } from '@mui/material';
import Header from './Header';
import { format, parseISO } from 'date-fns';
import { dateDifference, formatDateText, updateRows } from './CommonFunctions';
import { NumericFormat, PatternFormat } from 'react-number-format';
import { Link } from 'react-router-dom';
import {ModalBody, Table,Modal,Form,Tabs,Tab} from "react-bootstrap"
import CallLogsGraph from './CallLogsGraph';
import AddInquiryDialog from './AddInqueryDialog';
// import { Grid } from 'rsuite';
const url=process.env.REACT_APP_SERVER_URL;

const CallLogs = () => {
  const [callLogs, setCallLogs] = useState([]);
  const [currentCallLog, setCurrentCallLog] = useState({});
  const [showCallLogPopup, setShowCallLogPopup] = useState(false);
  // const url=process.env.REACT_APP_SERVER_URL;
  const [showCustomersPopup, setShowCustomersPopup] = useState(false);
  const [customerJson,setCustomerJson] =useState({})
  const [allCustomers, setAllCustomers] = useState({});
  const [showMessagePopup, setShowMessagePopup] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [showCallLogGraph, setShowCallLogGraph] = useState(false);
  const [showAddInquery, setShowAddInquery] = useState(false);
  useEffect(() => {
    
    fetchCallLogs();
    getAllCustomers();
    // getActiveTenancies();
  }, []);

  
  

  const fetchCallLogs = async () => {
    try {
      const response = await axios.get(`${url}/callLogs`);
      if(response && response.data){
        // setCallLogs(response.data);
        let dictionary={}
        // console.log(response.data)
        console.log(response.data[0]);

        for(let itr in response.data){
          const cr = response.data[itr];
          if(cr.phoneNumber in dictionary){
            dictionary[cr.phoneNumber].count++;
          }
          else{
            let tempJson = cr;
            tempJson["count"] = 1;
            dictionary[cr.phoneNumber] = tempJson;
          }
          console.log(cr.id)

        }
        let resultArray = [];
        for (let key in dictionary) {
          // console.log(dictionary[key]);
          resultArray.push(dictionary[key]);
        }
        console.log(resultArray[0])
        setCallLogs(resultArray);

      }
    } catch (error) {
      console.error('Error fetching call logs:', error);
    }
  };
  const getAllCustomers = async()=>{
    try {
      const response = await axios.get(`${url}/stayedCustomers`);
      const dict={};
      if(response && response.data){
        for(let itr in response.data){
          let cr = response.data[itr];
          dict[cr.phone] =cr;
        }
        setAllCustomers(dict);

      }
    } catch (error) {
      console.error('Error fetching customer logs:', error);
    }
  }

  const columns = [
    { field: 'id', headerName: 'ID', width: 60 },
    { field: 'callDate', headerName: 'Call Date', width: 200, 
        renderCell:(params)=>{
                      const currentRow=params.row;
                      if(currentRow.callDate){
                        const currentDate = new Date();
                      const dateObj = new Date(currentRow.callDate); // Convert the callDate string into a Date object
                    
                      // Check if the date is today
                      const isToday = currentDate.toDateString() === dateObj.toDateString();
                    
                      // Check if the date is yesterday
                      const yesterday = new Date();
                      yesterday.setDate(currentDate.getDate() - 1);
                      const isYesterday = yesterday.toDateString() === dateObj.toDateString();
                      if (isToday) {
                        return `Today ${dateObj.toLocaleTimeString()}`;
                      } else if (isYesterday) {
                        return `Yesterday ${dateObj.toLocaleTimeString()}`;
                      } else {
                        return dateObj.toLocaleString('en-US', {
                          // weekday: 'short',
                          month: 'short',
                          day: 'numeric',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric',
                          second: 'numeric'
                        });

                      }
                    }
                      

                      return null;
                      // currentRow.callDate ? format(parseISO(currentRow.callDate), 'MMM d, yyyy HH:mm:ss') : null; 

        }
    },
    {
      field: 'phoneNumber',
      headerName: 'Phone Number',
      width: 180,
      renderCell: (params) => {
        const phoneNumber = params.row.phoneNumber || "";
        const cleanedPhoneNumber = phoneNumber.startsWith('+1')
          ? phoneNumber.slice(2)
          : phoneNumber;
        const count = params.row.count || 0;

        return `${cleanedPhoneNumber} (${count})`;
      }
    },
     { field: 'isStayed', headerName: 'Name', width: 240,
      renderCell:(params)=>{
        const currentRow=params.row;
        const phoneNumber1 = currentRow.phoneNumber
        const cleanedPhoneNumber = phoneNumber1.startsWith('+1') ? phoneNumber1.slice(2) : phoneNumber1;
        if(cleanedPhoneNumber in allCustomers){
          // console.log(allCustomers[cleanedPhoneNumber])
          const cj = allCustomers[cleanedPhoneNumber];
        return <Link onClick={(e)=>
        {
          setCustomerJson({"phone": cleanedPhoneNumber,
            fname:null,lname:null
          });
          setShowCustomersPopup(true);

        }}> {cj.roomid}{' (' + cj.tenancyStatus[0].toUpperCase() +') '}
         - {cj.fname + " " + cj.lname}
        </Link>; 
      }
      else{
        return currentRow.name ? currentRow.name : null;
      }
    }
    
     },

    // { field: 'name', headerName: 'Name', width: 150 },

    { field: 'description', headerName: 'Description', width: 360, renderCell:(params)=>{
      const currentRow=params.row;
      return <a 
      // onClick={(e)=>{
      //   setShowCallLogPopup(true);
      //   setCurrentCallLog(params.row)
      // }} 
      // onDoubleClick={(e)=>{
      //   setShowCallLogPopup(true);
      //   setCurrentCallLog(params.row)
      // }}
      >
        {currentRow.description}
      </a> 
} },
    { field: 'requiredDate', headerName: 'Reservation Date', width: 150,renderCell:(params)=>{
        const currentRow=params.row;
        return currentRow.requiredDate ? formatDateText(currentRow.requiredDate) : null; 
} },
{ field: 'isSpam', headerName: 'Spam', width: 100, valueGetter: (params) => (params.row&&params.row.isSpam ? 'Yes' : 'No') },

{ field: 'callType', headerName: 'Type', width: 130 },
{ field: 'callDuration', headerName: 'Duration', width: 130 },
{ field: '', headerName: 'Actions', width: 360, renderCell:(params)=>{
  const currentRow=params.row;
  return <Link onClick={(e)=>{
    setPhoneNumber(currentRow.phoneNumber)
    setShowMessagePopup(true)}}>
    Message
  </Link> 
}}

    // { field: 'createdAt', headerName: 'Created At', width: 180 },
    // { field: 'updatedAt', headerName: 'Updated At', width: 180 }
  ];
  const handleRowDoubleClick = (params) => {
    console.log('Double-clicked row:', params.row);
    setCurrentCallLog(params.row);
    setShowCallLogPopup(true)
  };
  const saveCallLog = async (formData) => {
  try {
    const localDate = new Date(formData.callDate); // this includes `:00` seconds
    const callDateUTC = localDate.toISOString()
      .slice(0, 19) + 'Z'; // strips milliseconds, keeps "YYYY-MM-DDTHH:mm:ssZ"

    const payload = {
      ...formData,
      callDateUTC, // send in correct field
    };

    const response = await axios.post('/api/callLogs', payload);
    if (response) {
      fetchCallLogs();
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
};


  return (
    <>
    <Header/>
    <Button onClick={(e)=>setShowCallLogGraph(true)}>Visualise</Button>
    <Button onClick={(e)=>setShowAddInquery(true)}>Add Inquery</Button>

    <Box sx={{ height: 600, width: '100%' }}>
      <DataGrid
        rows={callLogs}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        checkboxSelection
        disableSelectionOnClick
        onRowDoubleClick={handleRowDoubleClick}
        
      />
    </Box>
    {showCallLogGraph && <CallLogsGraph callLogs = {callLogs} 
    showCallLogGraph={showCallLogGraph} 
    setShowCallLogGraph = {setShowCallLogGraph} />}
    {showCallLogPopup && <CallLogPopup showCallLogPopup={showCallLogPopup} 
    setShowCallLogPopup={setShowCallLogPopup}  setCallLogs={setCallLogs}
    callLog={currentCallLog} setCallLog = {setCurrentCallLog}
    />}
    {showCustomersPopup && <CustomersDetails showCustomersPopup={showCustomersPopup}
    setShowCustomersPopup ={setShowCustomersPopup} customerJson={customerJson}
    />}
    {showMessagePopup && <MessageSender showMessagePopup={showMessagePopup} 
    setShowMessagePopup={setShowMessagePopup}/>}

    {showAddInquery && <AddInquiryDialog open={showAddInquery} onClose={()=>{
      setShowAddInquery(false)
    }} onSubmit={(formData)=>{saveCallLog(formData)}}/>}
    </>
  );
};



const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0]; // 'YYYY-MM-DD'
};


const CallLogPopup = ({ showCallLogPopup, setShowCallLogPopup, callLog, setCallLog, setCallLogs }) => {
  const url = process.env.REACT_APP_SERVER_URL;

  const handleCloseCallLogPopup = () => {
    setShowCallLogPopup(false);
  };
  function updateRowsById(tempJson, mode, id) {
    setCallLogs((prevs) => updateRows(prevs, mode, id, tempJson));
  }

  const editCallLogDetails = async (updatedLog) => {
    try {
      const response = await axios.patch(`${url}/callLogs/${updatedLog.id}`, updatedLog);
      if (response?.data) {
        updateRowsById(updatedLog, "edit", updatedLog.id);

        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Optional: Set default date on open
  useEffect(() => {
    if (showCallLogPopup && !callLog.requiredDate) {
      setCallLog((prev) => ({ ...prev, requiredDate: getTodayDate() }));
    }
  }, [showCallLogPopup, callLog.requiredDate, setCallLog]);

  return (
    <Dialog
      open={showCallLogPopup}
      onClose={handleCloseCallLogPopup}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        component: 'form',
        onSubmit: (event) => {
          event.preventDefault();
          editCallLogDetails(callLog);
          handleCloseCallLogPopup();
        },
      }}
    >
      <DialogTitle>Edit Call Log</DialogTitle>

      <DialogContent>
        <Stack spacing={3} mt={1}>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            value={callLog.name || ""}
            onChange={(e) => setCallLog((prev) => ({ ...prev, name: e.target.value }))}
            InputLabelProps={{ shrink: true, sx: { fontSize: '1rem' } }}
          />

          <TextField
            fullWidth
            label="When do they need the room?"
            type="date"
            variant="outlined"
            value={callLog.requiredDate || getTodayDate()}
            onChange={(e) =>
              setCallLog((prev) => ({ ...prev, requiredDate: e.target.value }))
            }
            InputLabelProps={{ shrink: true, sx: { fontSize: '1rem' } }}
          />

          <TextField
            fullWidth
            label="Description"
            multiline
            minRows={3}
            variant="outlined"
            value={callLog.description || ""}
            onChange={(e) =>
              setCallLog((prev) => ({ ...prev, description: e.target.value }))
            }
            InputLabelProps={{ sx: { fontSize: '1rem' } }}
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleCloseCallLogPopup} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button type="submit" color="primary" variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};



const CustomersDetails =({showCustomersPopup, setShowCustomersPopup, customerJson})=>{
  const [customersData, setCustomersData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [showTenancyDetailsByLTTIModal,setShowTenancyDetailsByLTTIModal]=useState(false);

  useEffect(() => {
    
    getCustomersByName(customerJson.phone || null, 
      customerJson.fname || null, customerJson.lname || null);
  }, []);
  function handleCloseCustomersDetailsPopup(){
    setShowCustomersPopup(false);
  }
  const getCustomersByName= async(phone,fname,lname)=>{
    try{

        const response1=await axios.post(`${url}/searchCustomers`,{
            fname,
            lname,
            phone
        });
        const response2=await axios.post(`${url}/getTenancyByCustomerName`,{
          lname,
          fname,
          phone
        })
        console.log(response1.data)
        console.log(response2.data)

        var dict1={}; //Mapping customerId to customer details
        var dict2={}; //Mapping LTTI to Tenancy Details
        var dict3={}; //LTTI to customerId
        for(var i=0;i<response1.data.length;i++){
          const itr=response1.data[i];
          dict1[itr["id"]]=itr;
        }
        console.log(dict1)
        for(var i=0;i<response2.data.length;i++){
          const itr=response2.data[i];
          if(itr["status"]!="draft"){
            if(itr["longTermTenancyId"] in dict2){
              dict2[itr["longTermTenancyId"]].push(itr)
            }
            else{
              dict2[itr["longTermTenancyId"]]=[];
              dict2[itr["longTermTenancyId"]].push(itr)
            }
            dict3[itr["longTermTenancyId"]]=itr["customerid"];
          }
          
        }
        const tableData=[];
        for(var temp in dict2){
          var fcheckin=dict2[temp][0].checkin;
          var lcheckout=dict2[temp][dict2[temp].length-1].checkout;
          var customerId=dict3[temp];
          if(customerId in dict1){
            var tempJson={
              firstCheckin:fcheckin,
              lastCheckout:lcheckout,
              roomid: dict2[temp][0].roomid,
              longTermTenancyId:dict2[temp][0].longTermTenancyId,
              customerId:dict3[temp],
              fname:dict1[customerId].fname,
              lname:dict1[customerId].lname,
              phone:dict1[customerId].phone,
              address:dict1[customerId].address,
              state:dict1[customerId].state
            }
            tableData.push(tempJson)
          }
          

        }
        console.log(tableData)
        setCustomersData(tableData);
        // setShowCustomersPopup(true);
        

    }
    catch(error){
        console.log(error);
    }
   }
   const columns=[
       { field: 'Name', headerName: 'Name', width: 120, align: 'left' ,
       renderCell:(params)=>{
         return params.row.fname + ' ' + params.row.lname;
         
       } },
       { field: 'phone', headerName: 'Phone Number', width: 200, align: 'left', 
       renderCell:(params)=>{
         return <PatternFormat  format="+1 (###) ###-####" 
          value={params.row.phone} readOnly displayType="text" 
         />
         
       }
       },
      //  { field: 'address', headerName: 'Address', width: 200, align: 'left' ,
      //  renderCell:(params)=>{
      //    return params.row.address + ' - ' + params.row.state;
         
      //  } },
       { field: 'roomid', headerName: 'Room Number', width: 120, align: 'left' },
       { field: 'firstCheckin', headerName: 'Tenancy Period', width: 300, align: 'left' ,
       renderCell:(params)=>{
         return <Link
           onClick={()=>{
             setSelectedRow(params.row);
             setShowTenancyDetailsByLTTIModal(true);
           }}
         >{formatDateText(params.row.firstCheckin) + ' - ' + 
           formatDateText(params.row.lastCheckout)}
         </Link>
         
       } },
       { field: 'Stay Duration', headerName: 'Stay Duration', width: 140, align: 'left' ,
       renderCell:(params)=>{
         const diff=dateDifference(params.row.firstCheckin,params.row.lastCheckout);
         const weeks=Math.floor(diff/7);
         const days=diff%7;
         return weeks + ' weeks ' +  ( days>0 ? days + 'days' : '');
         
       } },
       
       {
         field: 'actions',
         type: 'actions',
         headerName: 'Actions',
         width:"100",
         renderCell:(params)=>{
           return <>Show Details
           </>
         }
       }
         
           
     ];
   return (
    <div>
      <React.Fragment>
        <Dialog
          open={showCustomersPopup}
          onClose={handleCloseCustomersDetailsPopup}
          fullWidth
        maxWidth="lg"
          
        >
          <DialogTitle>
              
          </DialogTitle>
          <DialogContent>

          <Box
              sx={{
                height: 500,
                width: '100%',
                // marginLeft:'5%',
                '& .actions': {
                  color: 'text.secondary',
                },
                '& .textPrimary': {
                  color: 'text.primary',
                },
              }}
            >
              <DataGrid rows={customersData} columns={columns}
              getRowId={(row) => row.longTermTenancyId}/>
              
            </Box>       


          </DialogContent>
        </Dialog>
      </React.Fragment>
      
    </div>

   );
}

const MessageSender = ({showMessagePopup, setShowMessagePopup, phoneNumber}) =>{
  const [description,setDescription]=useState(`Thank You for reaching out to Tidy Inn. We have rooms available for $400 a week including taxes. All rooms come with comfortable queen bed, a fridge, microwave and free WIFI. Please call us at 863 825 5007. You can see the room before renting.`);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    
    getAllMessageCategories();
  }, []);
  const handleCloseMessagePopup=()=>{
    setShowMessagePopup(false);
    // setResponseForSms("")
  }
  const handleInputChange = (e) => {
    // const textarea = e.target;
    // textarea.style.height = 'auto';  // Reset the height before recalculating
    // textarea.style.height = `${textarea.scrollHeight}px`;  // Set the height to match the scrollHeight
    setDescription(e.target.value);
};
const getAllMessageCategories = async()=>{
  try {
    const response = await axios.get(`${url}/messages`);
    if(response && response.data){
      // setCallLogs(response.data);
      setCategories(response.data);

    }
  } catch (error) {
    console.error('Error fetching call logs:', error);
  }
  
}
const sendSMS = async()=>{
  try {
    const tempJson ={"message": description, "phoneNumber": phoneNumber}
    const response = await axios.post(`${url}/pending_messages`, tempJson);
    if(response){
      // setCallLogs(response.data);

    }
  } catch (error) {
    console.error('Error fetching call logs:', error);
  }
  
}
  return (
    <Modal show={showMessagePopup} onHide={handleCloseMessagePopup}>
            <Modal.Header closeButton>
              {/* {responseForSms ? responseForSms: selectedPhoneNumbers.length +" Numbers Selected"} */}
            </Modal.Header>
            <ModalBody>
            
            <div style={{display:"inline"}}><Form.Label>Message Type</Form.Label>
            
              <Form.Select onChange={(e)=>setDescription(e.target.value)}>
                  {categories.map((row, index) => (
                    <option key={index} value={row.message}>
                      {row.category}
                    </option>
                  ))}
              </Form.Select></div>
              <br></br>
              <Form.Control
            as="textarea"
            size="lg"
            value={description}
            onChange={handleInputChange}
            style={{
              height: '20rem' // Ensure initial height is auto
          }}// Prevent the user from resizing the textarea manually
        />
             
            
            <Modal.Footer>
            <Button onClick={handleCloseMessagePopup}>Cancel</Button>
              <Button type="submit" 
              onClick={sendSMS}
              >Send Text</Button>
            </Modal.Footer>
    
        </ModalBody>
    
          </Modal>

  );
}

export default CallLogs;
